import React from 'react';
import AccountInfoCards from '../components/scheduled/AccountInfoCards';
import ScheduleCalendar from '../components/scheduled/ScheduleCalendar';
import { useSchedule } from '../components/scheduled/useSchedule';
import { useSetPageHeader } from '../contexts/PageHeaderContext';
import { usePageMeta } from '../utils/pageMeta.util';

const SchedulePage: React.FC = () => {
  usePageMeta({
    title: 'Dashboard | HCAE Client Portal',
    description: 'View your monthly coordinator schedule and assignments in the HCAE Client Portal.',
  });
  useSetPageHeader('Dashboard', 'View your coordinator schedule');

  const {
    currentDate,
    setCurrentDate,
    scheduleData,
    loading,
    sidebarOpen,
    selectedDate,
    selectedCoordinator,
    selectedDoc,
    setSelectedDoc,
    previewLoaded,
    setPreviewLoaded,
    handleDateClick,
    handleCoordinatorClick,
    closeSidebar,
    handleDownload,
  } = useSchedule();

  const calendarProps = {
    currentDate,
    setCurrentDate,
    scheduleData,
    loading,
    onDateClick: handleDateClick,
    sidebarOpen,
    selectedDate,
    selectedCoordinator,
    selectedDoc,
    setSelectedDoc,
    previewLoaded,
    setPreviewLoaded,
    onCoordinatorClick: handleCoordinatorClick,
    onCloseSidebar: closeSidebar,
    onDownload: handleDownload,
  };

  return (
    <div className="pb-5">
      <div className="hidden lg:flex gap-6 items-start">
        <div className="w-72 2xl:w-80 shrink-0">
          <AccountInfoCards />
        </div>
        <div className="flex-1 min-w-0 sticky top-0 self-start">
          <ScheduleCalendar {...calendarProps} />
        </div>
      </div>

      <div className="lg:hidden flex flex-col gap-6">
        <ScheduleCalendar {...calendarProps} />
        <AccountInfoCards />
      </div>

    </div>
  );
};

export default SchedulePage;